module.exports = __webpack_public_path__ + "img/payment-physical.ec513545.png";